module.exports = __webpack_public_path__ + "static/media/Cemplank.c5359908.svg";